import { useState } from "react";
import { Card, CardContent, Container, Grid } from "@material-ui/core";

import HeaderClientes from "components/_refactor/headers/clients.js";
import useSnackbar from "components/Alerts/Snackbar/useSnackbar";
import LoadingData from "components/Loading/LoadingData";
import StructureFields from "components/_refactor/fields/structure";

import LojistaSellIn from "./view/LojistaSellin";
import RepresentantSellIn from "./view/RepresentanteSellIn";
import verifyProfilesVision from "utils/verifyProfilesVision";

function DashboardSellIn() {
  const isAgent = verifyProfilesVision(["REPRESENTANTE", "REPRESENTANTE_ADM"]);

  const snackbar = useSnackbar();

  const [filters, setFilters] = useState();
  const [structureLoading, setStructureLoading] = useState(false);
  const [isLoadingAll, setIsLoadingAll] = useState(false);

  const handleApiError = (error, endpoint) => {
    snackbar.showMessage(error, {
      severity: "error",
    });  };

  return (
    <>
      <HeaderClientes section="Dashboard SellIn" subsection="Dashboard" />
      <Container maxWidth={false} style={{ marginTop: "-4rem" }}>
        <Card>
          <CardContent>
            <Grid container spacing={2}>
              <StructureFields
                onStructureFieldsChange={setFilters}
                disableAll={isLoadingAll}
                onStructureFieldsLoad={setStructureLoading}
                hideFields={
                  isAgent
                    ? ["channel", "brand"]
                    : ["channel", "representative", "brand"]
                }
              />
            </Grid>
          </CardContent>
        </Card>

        {isLoadingAll && (
          <LoadingData searching={true} label="Buscando dados..." />
        )}

        {isAgent ? (
          <RepresentantSellIn
            filters={filters}
            structureLoading={structureLoading}
            setIsLoadingAll={setIsLoadingAll}
            handleApiError={handleApiError}
          />
        ) : (
          <LojistaSellIn
            filters={filters}
            structureLoading={structureLoading}
            setIsLoadingAll={setIsLoadingAll}
            handleApiError={handleApiError}
          />
        )}
      </Container>
    </>
  );
}

export default DashboardSellIn;
